/* eslint-disable */

/**
 * Js browser compatible event module
 * Inspired by John Resig: http://ejohn.org/blog/flexible-javascript-events/
 *
 */

module.exports = {
    isMatchingKeyEvent: function (event, eventType, keys) {
        if (event.type === eventType || eventType === 'any') {
            var keyPressed = event.which || event.charCode;
            if (typeof keys !== 'object') {
                keys = [keys];
            }
            return keys.indexOf(keyPressed) !== -1;
        }
        return false;
    },
    addEvent: function( obj, type, fn ) {
        if (obj.addEventListener) {
            obj.addEventListener( type, fn, false );
        } else {
            obj['e'+type+fn] = fn;
            obj[type+fn] = function(){obj['e'+type+fn]( window.event );};
            obj.attachEvent( 'on'+type, obj[type+fn] );
        }
    },
    removeEvent: function( obj, type, fn ) {
        if (obj.removeEventListener) {
            obj.removeEventListener( type, fn, false );
        } else {
            obj.detachEvent( 'on'+type, obj[type+fn] );
            obj[type+fn] = null;
        }
    },
    triggerEvent: function(obj, type, data, cancellable) {
        var e = document.createEvent('Event');

        cancellable = cancellable || false;

        if (e.type === '') {
            e.initEvent(type, true, cancellable);
        }

        e.data = data || {};

        obj.dispatchEvent(e);
    }
};



/** WEBPACK FOOTER **
 ** ./assets/js/eventie.js
 **/